<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="65%"
        max-height="80%"
        scrollable
    >
        <v-card>
            <v-toolbar :color="debugData.data.color">
                <v-card-title>
                    <span class="text-h5">
                        {{
                            $t("strings.operator-debug", {
                                value: debugData.label,
                            })
                        }}
                        ({{ debugData.id }})
                    </span>
                </v-card-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12">
                        <v-list lines="two">
                            <v-list-item
                                v-for="(error, idx) in debugData.data.errors"
                                :key="idx"
                                :subtitle="
                                    error.type.replace(/(?<!^)([A-Z])/g, ' $1')
                                "
                            >
                                <template v-slot:title>
                                    <span class="text-wrap text-break">{{
                                        localizationErrorTitle(error)
                                            .charAt(0)
                                            .toUpperCase() +
                                        localizationErrorTitle(error).slice(1)
                                    }}</span>
                                </template>
                                <template v-slot:prepend>
                                    <v-avatar :color="error.level">
                                        <v-icon
                                            color="white"
                                            :icon="
                                                error.type == 'TaskExecError'
                                                    ? 'mdi-alert'
                                                    : 'mdi-alert-outline'
                                            "
                                        >
                                        </v-icon>
                                    </v-avatar>
                                </template>
                                <v-divider class="mt-2"></v-divider>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" variant="text" @click="dialog = false">
                    {{ $t("labels.cancel") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "DialogDebug",
    props: {
        showDialogDebug: Boolean,
        debugData: Object,
    },
    data: () => ({ debug: {} }),
    computed: {
        dialog: {
            get() {
                return this.showDialogDebug;
            },
            set(value) {
                this.$emit("toggleDialogDebug", value);
            },
        },
    },
    methods: {
        getLabel(label) {
            if (typeof label !== "string") {
                return label == null ? "" : String(label);
            }
            const labelKey =
                "labels." + label.replace(/\s+/g, "-").toLowerCase();
            const translated = this.$t(labelKey);

            return translated !== labelKey ? translated : label;
        },

        localizationErrorTitle(error) {
            const translationKey = `debug.${error?.errorName}`;

            const translation = this.$t(translationKey, error?.data ?? {});

            return translation !== translationKey
                ? translation
                : error?.fullMessage || "Unknown error";
        },
    },
};
</script>
